<template>

<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.0962 7.66851C12.0962 4.40803 14.7393 1.76489 17.9998 1.76489C21.2602 1.76489 23.9034 4.40803 23.9034 7.66851V17.9998C23.9034 21.2602 21.2602 23.9034 17.9998 23.9034C14.7393 23.9034 12.0962 21.2602 12.0962 17.9998V7.66851Z" fill="white"/>
<path d="M9.51349 17.7694V17.9999C9.51349 20.2507 10.4076 22.4092 11.9991 24.0008C13.5906 25.5922 15.7492 26.4863 17.9999 26.4863C20.2507 26.4863 22.4092 25.5922 24.0008 24.0008C25.5923 22.4092 26.4864 20.2507 26.4864 17.9999V17.7694C26.4864 16.9542 27.1471 16.2935 27.9623 16.2935H28.7002C29.5154 16.2935 30.1761 16.9542 30.1761 17.7692V17.9999C30.1761 21.2292 28.8933 24.3264 26.6098 26.6097C24.7658 28.4539 22.3912 29.6452 19.8448 30.0356V32.7589C19.8448 33.5741 19.1841 34.2348 18.3689 34.2348H17.631C16.8158 34.2348 16.1551 33.5741 16.1551 32.7589V30.0356C13.6087 29.6452 11.2341 28.4539 9.39006 26.6097C7.10657 24.3264 5.82373 21.2292 5.82373 17.9999V17.7694C5.82373 16.9542 6.48452 16.2935 7.29963 16.2935H8.03759C8.8527 16.2935 9.51349 16.9542 9.51349 17.7694Z" fill="white"/>
</svg>


</template>

<script>
export default {
  name: 'IconBtnMicroOn',
  components: {
  },

  data: () => {
    return {
    }
  },

  mounted () {
  },

  methods: {
  }
}
</script>
